<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="signup">
                <template slot="header">
                  <h4 class="card-title text-center">Reset Password</h4>
                </template>
                <ValidationObserver ref="forgetPasswordForm" v-slot="{ handleSubmit }">
                  <form v-on:keyup.enter.native="handleSubmit(resetPassword)">
                    <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                      <fg-input
                        :error="errors[0]"
                        v-model="form.email"
                        addon-left-icon="nc-icon nc-email-85"
                        placeholder="Email adress"
                      ></fg-input>
                    </ValidationProvider>
                    <ValidationProvider name="password" rules="required|min:6" v-slot="{ errors }">
                      <fg-input
                        :error="errors[0]"
                        v-model="form.password"
                        addon-left-icon="nc-icon nc-key-25"
                        placeholder="Password"
                        type="password"
                      ></fg-input>
                    </ValidationProvider>
                    <ValidationProvider
                      name="password_confirmation"
                      rules="required|min:6|confirmed:password"
                      v-slot="{ errors }"
                    >
                      <fg-input
                        :error="errors[0]"
                        v-model="form.password_confirmation"
                        addon-left-icon="nc-icon nc-key-25"
                        placeholder="Confirm Password"
                        type="password"
                      ></fg-input>
                    </ValidationProvider>
                    <div class="text-center">
                      Go back to
                      <router-link :to="{name: 'Login'}">Login</router-link>
                    </div>
                    <p-button
                      native-type="submit"
                      slot="footer"
                      type="warning"
                      round
                      block
                      class="mb-3"
                      @click.native.prevent="handleSubmit(resetPassword)"
                    >Reset Password</p-button>
                  </form>
                </ValidationObserver>
              </card>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/background-2.jpg)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Checkbox, Button } from "src/components/UIComponents";
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import { Message } from "element-ui";

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
        password_confirmation: "",
        token: null
      }
    };
  },
  methods: {
    clearField(){
       this.form.email = "";

    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({type: type, message: message, duration: 500});
    },
    resetPassword() {
      this.form.token = this.$route.params.token;
      this.$store
        .dispatch("user/resetPassword", this.form)
        .then(response => {
          this.showAlertMessage(response.data.message, "success");
          this.$router.push({ name: "Login" });
        })
        .catch(error => {
          this.showAlertMessage(error.response.data.message, "error");
        });
    }
  },

  beforeDestroy() {
    this.closeMenu();
  }
};
</script>
<style>
</style>
